import Icon from '@components/Icon';
import Text from '@components/Text';
import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import { EverGreenStyle } from '@utils/Style/everGreen';
import React from 'react'



const Container = styled.div<Pick<NameSelectorItemProps,'selected'>>`
  display: block;
  margin : 4px;
  width: max-content;
  height: max-content;
  padding: 8px 30px;
  background: #FFFFFF;
  border: 1px solid ${EverGreenStyle.colors.primary};
  border-radius: 100px;
  cursor: pointer;
`;

const ContainerSelectedDefaultClass = css`
  border: 1px solid #F5F5F5;
  background-color:#F5F5F5;
`;
const ContainerSelectedSSClass = css`
  display: flex;
  img {
    margin-left: 8px;
  }
  p {
    text-transform: lowercase;
    :first-letter {
      text-transform: capitalize;
    }
  }
`;

const ContainerSelectedClass = css`
  border: 1px solid ${EverGreenStyle.colors.primary};
  background-color:${EverGreenStyle.colors.primary};
`;

const TitleClass = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  letter-spacing: 0.08em;
  color: ${EverGreenStyle.colors.primary};
`;

const TitleSelectedClass = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  letter-spacing: 0.08em;
  color: #FFFFFF;
`;
const TitleSelectedDefaultClass = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  letter-spacing: 0.08em;
  color: #9D9D9D;
`;

export interface NameSelectorItemProps{
  id?:string;
  title: string;
  selected:boolean;
  variant: 'default' | 'selected';
  onClick?: () => void;
  nsFor?: string;
}

function NameSelectorItem({title,selected,id,variant,onClick, nsFor}:NameSelectorItemProps) {
  return (
    <Container onClick={onClick} id={id} selected={selected} className={`
      ${variant === 'selected' ? ContainerSelectedClass : (selected ? ContainerSelectedDefaultClass : '')}
      ${nsFor === "shieldStartter" && ContainerSelectedSSClass}
    `}>
      <Text className={variant === 'selected' ? TitleSelectedClass : (selected ? TitleSelectedDefaultClass : TitleClass)}>{title}</Text>
      {nsFor === "shieldStartter" && variant === 'selected' && <Icon name='circle-cancel-black'></Icon>}
    </Container>
  )
}

export default NameSelectorItem;